export default __webpack_public_path__ + "static/media/mainz_l.6f949c05.jpg";